import React from 'react'
import { mount, shallow } from 'enzyme'

import { QuickLoanAnalysis } from '../QuickLoanAnalysis'
import loan from './testData/loan'
import years from './testData/years'
import products from './testData/products'
import unavailableProducts from "../helpers/unavailableProducts"

describe('<QuickLoanAnalysis />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    const guarantors = loan.businesses.reduce((acc, business) => acc.concat(business.guarantors), [])
    const businessCashflowData = loan.businesses.reduce((acc, business) => acc.concat(business.cashflowData), [])
    const guarantorCashflowData = guarantors.reduce((acc, guarantor) => acc.concat(guarantor.cashflowData), [])
    const allCashflowData = businessCashflowData.concat(guarantorCashflowData)
    props = {
      allCashflowData,
      loan,
      entity: loan.businesses[0],
      entities: loan.businesses.concat(loan.businesses[0].guarantors),
      loanAmount: loan.amount,
      years,
      product: loan.product,
      data: {
        loading: false,
        error: undefined,
        products
      }
    }
    wrapper = mount(<QuickLoanAnalysis {...props} />)
    instance = wrapper.instance()
  })

  describe('#get product', () => {
    it('should return the product matching the currentProduct', () => {
      expect(instance.product.name).toBe('First Home - SBA')
    })
  })

  describe('#outstandingLoansReducer', () => {
    it('should sum the monthly payment of each loan * 12 if its remaining payments are above the months remaning cutoff and is not being refinanced', () => {
      const monthsRemainingCutoff = 6
      const outstandingLoans = {
        333: {
          monthlyPayment: 2000,
          monthsRemaining: 12,
          refinance: false,
          active: true
        },
        534: {
          monthlyPayment: 10000,
          monthsRemaining: 24,
          refinance: true,
          active: true
        },
        444: {
          monthlyPayment: 4000,
          monthsRemaining: 20,
          refinance: false,
          active: true
        },
        100: {
          monthlyPayment: 20000,
          monthsRemaining: 4,
          refinance: false,
          active: true
        }
      }
      const expected = 72000
      const yearlyOutstandingLoanPayments = Object.keys(outstandingLoans).reduce((acc, key) => instance.outstandingLoansReducer({ acc, key, loans: outstandingLoans, monthsRemainingCutoff }), 0)
      expect(yearlyOutstandingLoanPayments).toBe(expected)
    })
  })
  describe('#renderDebts', () => {
    let debts
    beforeEach(() => {
      debts = mount(
        <div>
          {instance.renderDebts()}
        </div>
      )
    })
    it('should return one <DebtRow /> per outstanding loan', () => {
      expect(debts.find('QuickLoanAnalysis__DebtRow')).toHaveLength(wrapper.prop('entity').outstandingLoans.length)
    })
    it('should render the lender name, monthly payment, principal balance, and remaining payments for each loan', () => {
      const { outstandingLoans } = wrapper.prop('entity')
      const rids = Object.keys(wrapper.state('loans'))
      debts.find('QuickLoanAnalysis__DebtRow').forEach((node, i) => {
        const cells = node.find('QuickLoanAnalysis__DebtCell')
        const rid = parseInt(rids[i], 10)
        const { monthlyPayment, monthsRemaining, lender, principalBalance } = outstandingLoans.find(loan => loan.rid === rid)
        expect(cells.at(0).text()).toBe(lender)
        expect(cells.at(1).text()).toBe(`$${principalBalance.toLocaleString('en')}`)
        expect(cells.at(2).text()).toBe(`$${monthlyPayment.toLocaleString('en')}`)
        expect(cells.at(3).text()).toBe(monthsRemaining.toString())
      })
    })
  })

  describe('#renderProducts', ()=> {
    describe('#when data is loading', ()=> {
      it('should return sorted list', ()=> {
        const options = wrapper.find('option');
        const sortedProducts = products
          .filter((p) => !unavailableProducts(p.name))
          .sort((a, b) => a.name.localeCompare(b.name))

        expect(options).toHaveLength(sortedProducts.length);

        sortedProducts.forEach((prod, index) => {
          const option = options.at(index);

          expect(option.prop('id')).toBe(prod.name);
          expect(option.key()).toBe(prod.rid.toString());
          expect(option.prop('value')).toBe(prod.name);
          expect(option.text()).toBe(prod.name);
        });
      })
    })

  })

  describe('#isDisabled', () => {
    describe('when has a hard-pull', () => {
      it('should be true', () => {
        props.loan.hardCreditPulled = true
        wrapper.setProps({ props })
        expect(instance.isDisabled).toBeTruthy()
      })
    })
    describe('when does not has a hard-pull', () => {
      it('should be false', () => {
        props.loan.hardCreditPulled = false
        wrapper.setProps({ props })
        expect(instance.isDisabled).toBeFalsy()
      })
    })
  })
  describe('#blockProductChange', () => {
    describe('when has a hard pull', () => {
      beforeEach(() => {
        props.loan.hardCreditPulled = true
        wrapper.setProps({ props })
      })
      describe('when the product is the same', () => {
        beforeEach(() => {
          props.product.name = 'First Home - SBA'
          wrapper.setState({ props })
        })
        it('should be false', () => {
          expect(instance.blockProductChange).toBeFalsy()
        })
      })
      describe('when the product is different', () => {
        beforeEach(() => {
          props.product.name = 'SmartBiz - SBA'
          wrapper.setState({ props })
        })
        it('should be true', () => {
          expect(instance.blockProductChange).toBeTruthy()
        })
      })
    })
    describe('when does not has a hard pull', () => {
      beforeEach(() => {
        props.loan.hardCreditPulled = false
        wrapper.setProps({ props })
      })
      describe('when the product is the same', () => {
        beforeEach(() => {
          props.product.name = 'First Home - SBA'
          wrapper.setState({ props })
        })
        it('should be false', () => {
          expect(instance.blockProductChange).toBeFalsy()
        })
      })
      describe('when the product is different', () => {
        beforeEach(() => {
          props.product.name = 'SmartBiz - SBA'
          wrapper.setState({ props })
        })
        it('should be false', () => {
          expect(instance.blockProductChange).toBeFalsy()
        })
      })
    })
  })
  describe('#isLenderSame', () => {
    describe('when both products are from same lender', () => {
      it('should return true', () => {
        const isLenderSame = instance.isLenderSame(props.loan.product.lenderKey, props.product.lenderKey)
        expect(isLenderSame).toBe(true)
      })
    })
    describe('when both products are not from same lender', () => {
      it('should return false', () => {
        props.loan.product = products[1]
        props.product = products[8]
        wrapper.setProps({ props })
        const isLenderSame = instance.isLenderSame(props.loan.product.lenderKey, props.product.lenderKey)
        expect(isLenderSame).toBe(false)
      })
    })
  })
  describe('#isLoanAmountValidMinMax', () => {
    describe('when loan amount is between the ValidMinMax', () => {
      it('should be true', () => {
        expect(instance.isLoanAmountValidMinMax()).toBeTruthy()
      })
    })
    describe('when loan amount is not between the ValidMinMax', () => {
      beforeEach(() => {
        props.loanAmount = 1000
        wrapper.setProps({ ...props })
      })
      it('should be false', () => {
        const result = instance.isLoanAmountValidMinMax()
        expect(result).toBeFalsy()
      })
    })
  })
})
